const decodeProcessParameters = (params) => params.map(param => ([
  `${param.name}:${param.code}`
])).join('\n')

const encodeProcessParameters = (params, idResponse = 0) => params.split('\n').map(parameter => {
  const [name, code] = parameter.split(':')
  return ({
    idResponse: idResponse,
    name: name.trim(),
    code: code.trim()
  })
})

const cutStringByScreenWidth = (text) => {
  let textArray = text.split('')
  let width = screen.width
  let arrayLength = textArray.length
  if (arrayLength > 16) {
    if (width > 1900 && arrayLength > 50) {
      return cutAndJoinTextArray(textArray, 50)
    }
    if (screen.width > 1700 && textArray.length > 40) {
      return cutAndJoinTextArray(textArray, 40)
    }
    if (screen.width > 1600 && textArray.length > 34) {
      return cutAndJoinTextArray(textArray, 34)
    }
    if (screen.width > 1450 && textArray.length > 30) {
      return cutAndJoinTextArray(textArray, 30)
    }
    if (screen.width > 1250 && textArray.length > 22) {
      return cutAndJoinTextArray(textArray, 22)
    }
    return cutAndJoinTextArray(textArray, 16)
  }
  return text
}

const cutAndJoinTextArray = (array, position) => {
  array.splice(position, array.length)
  array[array.length] = '...'
  return array.join('')
}

const normalizeText = (text) => {
  return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export default {decodeProcessParameters, encodeProcessParameters, cutStringByScreenWidth, normalizeText}



// WEBPACK FOOTER //
// ./src/lib/Strings.js